module.exports = __webpack_public_path__ + "static/media/IMG-3.29cdc4c3.jpg";